import { ObjectValues } from '@types';

export const AmplitudeEvents = {
    attendeeClosedAccount: 'Attendee Closed Account',
    attendeeClickedBanner: 'Attendee Clicked Banner',
    attendeePageViewed: 'Attendee Page Viewed',
    attendeeRegistered: 'Attendee Registered',
    attendeeMessageWrite: 'Attendee Message Write',
    attendeeMessageRead: 'Attendee Message Read',

    attendeeSurveyViewed: 'Attendee Survey Viewed',
    attendeeSurveyOptionSelected: 'Attendee Survey Option Selected',
    attendeeSurveyOptionUnselected: 'Attendee Survey Option Unselected',
    attendeeSurveyClosed: 'Attendee Survey Closed',
    attendeeSurveyStepSaved: 'Attendee Survey Step Saved',
    attendeeSurveyFinished: 'Attendee Survey Finished',
} as const;

export type AmplitudeEventName = ObjectValues<typeof AmplitudeEvents>;

const SurveyNames = {
    preferences: 'preferences',
} as const;
export type SurveyName = ObjectValues<typeof SurveyNames>;
export type PreferencesSurveyStep = 'interests' | 'frequency';
export interface SurveySteps extends Record<SurveyName, PreferencesSurveyStep> {
    [SurveyNames.preferences]: PreferencesSurveyStep;
}
export type SurveyStep = ObjectValues<SurveySteps>;

export interface AmplitudeEventsData
    extends Record<AmplitudeEventName, Record<string, any> | undefined> {
    // TODO: type more strictly
    [AmplitudeEvents.attendeeClosedAccount]: Record<string, any> | undefined;
    [AmplitudeEvents.attendeeClickedBanner]: Record<string, any> | undefined;
    [AmplitudeEvents.attendeePageViewed]: Record<string, any> | undefined;
    [AmplitudeEvents.attendeeRegistered]: Record<string, any> | undefined;
    [AmplitudeEvents.attendeeMessageWrite]: Record<string, any> | undefined;
    [AmplitudeEvents.attendeeMessageRead]: Record<string, any> | undefined;

    [AmplitudeEvents.attendeeSurveyViewed]: {
        name: SurveyName;
        // TODO!: add more strict typing - connect specific survey with it's steps (steps based on name)
        step: SurveyStep;
    };
    [AmplitudeEvents.attendeeSurveyOptionSelected]: {
        name: SurveyName;
        step: SurveyStep;
        field: string;
        value: string;
    };
    [AmplitudeEvents.attendeeSurveyOptionUnselected]: {
        name: SurveyName;
        step: SurveyStep;
        field: string;
        value: string;
    };
    [AmplitudeEvents.attendeeSurveyClosed]: {
        name: SurveyName;
        step: SurveyStep;
    };
    [AmplitudeEvents.attendeeSurveyStepSaved]: {
        name: SurveyName;
        step: SurveyStep;
    };
    [AmplitudeEvents.attendeeSurveyFinished]: {
        name: SurveyName;
    };
}
